export const SET_DAYS = 'SET_DAYS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_TECH_ASSIGNMENTS = 'SET_TECH_ASSIGNMENTS'
export const SET_TECH = 'SET_TECH'
export const SET_TECHS = 'SET_TECHS'
export const SET_TECHDATA = 'SET_TECHDATA'
export const SET_ADDRESS = 'SET_ADDRESS'
export const SET_TECH_LOCATION = 'SET_TECH_LOCATION'
export const SET_TECH_STATUS = 'SET_TECH_STATUS'
export const SET_CENTER = 'SET_CENTER'
export const SET_TECH_SCHEDULE = 'SET_TECH_SCHEDULE'

export const DISPATCH_SEARCH_TERM = 'DISPATCH_SEARCH_TERM'
export const DISPATCH_PAGE_SIZE = 'DISPATCH_PAGE_SIZE'
export const DISPATCH_SORT_DIR = 'DISPATCH_SORT_DIR'
export const DISPATCH_ORDER_BY = 'DISPATCH_ORDER_BY'
export const DISPATCH_FILTER_BY = 'DISPATCH_FILTER_BY'



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/types.js